import React from "react";
import { EntityAvatar } from "@/components/core/EntityAvatar";

interface FundAvatarProps {
  fundKey: string;
  name?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const FundAvatar: React.FC<FundAvatarProps> = ({
  fundKey,
  name,
  className,
  size = "md",
}) => {
  return (
    <EntityAvatar
      entityType="fund"
      identifier={fundKey}
      name={name}
      className={className}
      size={size}
    />
  );
};

export default FundAvatar;
